var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable max-lines-per-function */
import React, { useEffect, useRef, useImperativeHandle, useState } from 'react';
import CBForm from '@cb/apricot/CBForm';
import CBInternationalPhone from '@cb/apricot/CBInternationalPhone';
import cn from 'classnames';
import { useUID } from 'react-uid';
// ref is for the wrapping div
export const InputPhoneInt = React.forwardRef((_a, ref) => {
    var { inputId, dropdownId, validationMessageId, countries, preferredCountries = ['us', 'de'], defaultCountry = 'us', country, defaultValue, value, placeholder = '(###) ###-####', label, labelId, ariaLabel, ariaDescribedby, className, labelClassName, floating = false, condensed = false, disabled = false, required = false, validation, validationMsg, helperClassName, ariaLive, cbRef, maxLength, onCountryChange, onNumberChange, onChange } = _a, props = __rest(_a, ["inputId", "dropdownId", "validationMessageId", "countries", "preferredCountries", "defaultCountry", "country", "defaultValue", "value", "placeholder", "label", "labelId", "ariaLabel", "ariaDescribedby", "className", "labelClassName", "floating", "condensed", "disabled", "required", "validation", "validationMsg", "helperClassName", "ariaLive", "cbRef", "maxLength", "onCountryChange", "onNumberChange", "onChange"]);
    const CBInternationalPhoneRef = useRef(null);
    const inputDropdownRef = useRef(null);
    const inputRef = useRef(null);
    const [code, setCode] = useState();
    const uid = useUID();
    // eslint-disable-next-line no-param-reassign
    inputId = inputId || `apricot_input_phone_${uid}`;
    // eslint-disable-next-line no-param-reassign
    dropdownId = dropdownId || `apricot_dropdown_${uid}`;
    // eslint-disable-next-line no-param-reassign
    validationMessageId = validationMessageId || `apricot_input_err_${uid}`;
    useImperativeHandle(ref, () => inputRef.current);
    useEffect(() => {
        const internationalPhonePlugin = CBInternationalPhone({
            elem: inputDropdownRef.current,
            countries,
            defaultCountry,
            defaultValue,
            preferredCountries,
            placeholder,
            maxLength,
            onCountryChange: (countryCode) => {
                setCode(countryCode);
                onCountryChange && onCountryChange(countryCode);
                // to cover change event for input
                const e = new Event('change');
                onChange && onChange(e, countryCode);
            },
            onNumberChange,
        });
        floating && CBForm.floatingLabel(inputRef.current);
        if (cbRef) {
            // eslint-disable-next-line no-param-reassign
            cbRef.current = internationalPhonePlugin;
        }
        CBInternationalPhoneRef.current = internationalPhonePlugin;
        return () => {
            internationalPhonePlugin && internationalPhonePlugin.destroy();
        };
    }, [disabled]);
    useEffect(() => {
        if (CBInternationalPhoneRef && country) {
            CBInternationalPhoneRef.current.updateCountry(country);
        }
    }, [country]);
    useEffect(() => {
        if (CBInternationalPhoneRef && value) {
            CBInternationalPhoneRef.current.updateNumber(value);
        }
    }, [value]);
    useEffect(() => {
        if (CBInternationalPhoneRef && maxLength) {
            CBInternationalPhoneRef.current.updateMaxLength(maxLength);
        }
    }, [maxLength]);
    const mainClassName = cn('cb-input', 'cb-int-phone', floating && label && 'cb-floating-label', condensed && 'cb-input-condensed', disabled && 'cb-disabled', validation && `cb-validation-${validation}`, validation && 'display-block', className);
    const labelClass = cn(label && required && 'cb-required', labelClassName);
    const helperClass = cn('cb-input-helper', validation && `cb-validation-${validation}`, helperClassName);
    const getDescribedBy = () => {
        if (validation) {
            if (validationMsg && ariaDescribedby) {
                return `${ariaDescribedby} ${validationMessageId}`;
            }
            return validationMsg ? validationMessageId : ariaDescribedby;
        }
        return ariaDescribedby;
    };
    const describedbyValue = getDescribedBy() || null;
    /**
     * Input changed - pass the update in the callback
     */
    const onInputChange = (e) => {
        onChange && onChange(e, code);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: mainClassName, ref: inputDropdownRef, "data-cbtrack-comp": "apricot-react:int-phone" },
            React.createElement("label", { className: labelClass, htmlFor: inputId, id: labelId }, label),
            React.createElement("div", { className: "cb-int-phone-container" },
                React.createElement("div", { className: "cb-flag-dropdown" },
                    React.createElement("a", { href: "/#", className: cn('cb-flag-selected', disabled && 'cb-disabled'), id: dropdownId, role: "button", "aria-expanded": "false", "aria-haspopup": "listbox", "aria-controls": inputId },
                        React.createElement("span", { className: "cb-flag" },
                            React.createElement("span", { className: "cb-dial-code" }),
                            React.createElement("span", { className: "sr-only" })),
                        React.createElement("span", { className: "cb-dropdown-toggle" },
                            React.createElement("i", { className: "cb-icon cb-down", "aria-hidden": "true" }),
                            React.createElement("i", { className: "cb-icon cb-up cb-hidden", "aria-hidden": "true" }))),
                    React.createElement("span", { className: "cb-line" }),
                    React.createElement("ul", { className: "cb-country-list", role: "listbox" })),
                React.createElement("input", Object.assign({ type: "text", id: inputId, "aria-label": ariaLabel, ref: inputRef, disabled: disabled, "aria-describedby": describedbyValue || undefined, onChange: onInputChange }, props)))),
        validation && validationMsg && (React.createElement("p", { id: validationMessageId, className: helperClass, "aria-live": ariaLive }, validationMsg))));
});
//# sourceMappingURL=InputPhoneInt.js.map